import { useLevels } from "@dyl/systems/LevelsManager";
import { Button, ButtonGroup } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSettings } from "@dyl/systems/SettingsManager";
import { usePreviousLocation } from "@dyl/systems/PrevPathContext";

export default function LevelSelect() {
    const navigate = useNavigate();
    const { levelSelectPath } = useSettings();
    const { levels, setGlobalLevel } = useLevels();
    const previousLocation = usePreviousLocation();
    const pageList = ['welcome','tests','components','tasks', 'rubrics', 'passwords', 'misspelling-words', 'medias', 'amtt'];

    const GoTo = (l) => () => {
        const pathParts = (
            previousLocation?.pathname?.includes('unauthorized') ||
            previousLocation?.pathname === undefined ||
            !pageList.includes(previousLocation?.pathname?.split("/")?.[2]) )
            ? levelSelectPath.split("/") : previousLocation?.pathname.split("/");
        let startupPage = pathParts[2];
        const newUrl = `/${l.label}/${startupPage}`;
        setGlobalLevel(l);
        navigate(newUrl);
    };

    return (
        <ButtonGroup size="large" aria-label="large button group" style={{ justifyContent: 'center', width: '100%' }}>
            {levels.map(l =>
                <Button key={l.level_id} onClick={GoTo(l)}>
                    {l.label}
                </Button>
            )}
        </ButtonGroup>
    )
};